import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaDynamicSpecific, TypedSchema } from '../../types'

export class SchemaDynamicDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaDynamicSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaDynamicSpecific) {
    return schema
  }

  override infer(
    target: any,
    schema: SchemaDynamicSpecific,
    path: PropertyKey[] = []
  ): TypedSchema {
    return this.__r_hoistMetadata(
      { ...this.inferOnlySchema(schema, path), value: target },
      schema
    )
  }

  override inferOnlySchema(
    schema: SchemaDynamicSpecific,
    path: PropertyKey[] = []
  ): TypedSchema {
    const target = this.getCurrentNode()
    if (target === undefined) return UnknownSchema
    if (schema?.infer) {
      let result = schema.infer(target, (target, schema) => {
        return super.infer(target, schema, path)
      })
      if (schema.name !== undefined) result = { ...result, name: schema.name }
      return result
    }
    return {
      ...schema,
      ...UnknownSchema
    }
  }

  override inferTypeScript(
    schema: SchemaDynamicSpecific,
    path: PropertyKey[]
  ): string {
    return super.inferTypeScript(this.infer(schema.value, schema, path), path)
  }

  override prune(target: any): any {
    return target
  }

  /**
   * 动态类型不转换，因为类型变了，转换效果就会不稳定
   * @param target
   * @returns
   */
  override transform(
    value: any,
    schema: SchemaDynamicSpecific,
    path: PropertyKey[] = []
  ) {
    const target = this.getCurrentNode()
    if (target === undefined) return value
    if (schema.transform) {
      return schema.transform(
        value,
        target,
        (value, schema = super.infer(target, undefined, path)) =>
          super.transform(
            value,
            this.store.definition.getInWithSchema(schema, path.slice(1)),
            path
          )
      )
    }
    return value
  }

  override validate(
    value: any,
    schema: SchemaDynamicSpecific,
    path: PropertyKey[]
  ): void {
    if (this.validateMetadata(value, schema)) return
    if (schema.test && this.getCurrentNode()) {
      schema.test(value, this.getCurrentNode(), (value, schema) =>
        super.test(
          value,
          this.store.definition.getInWithSchema(schema, path.slice(1)),
          path
        )
      )
    }
  }
}
